import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';


export abstract class Configuration {
    bioIdApiUrl: string = "";
    recommendationsUrl: string = "";
}

@Injectable({ providedIn: 'root' })
export class ConfigService extends Configuration {
    constructor() {
        super();
    }

    loadConfig() {
        this.bioIdApiUrl = environment.apiUrl;
        this.recommendationsUrl = environment.recommendationsUrl;
    }
}
